var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThought(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 6802,
    transform: "translate(-777 -5603)",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -31.5,
    y: -31.5,
    width: 399,
    height: 311,
    rx: 15.5,
    stroke: "#202233",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 16,
    fill: "#FFEDD8"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5179 58.7633L21 38.9087L29.4005 30.3633H51.5637L60 38.9087L40.5179 58.7633ZM22.9661 38.9087L40.5179 56.7633L58.0339 38.9087L51.0275 31.7815H30.0082L22.9661 38.9087Z",
    fill: "#FD7E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5181 59.9998L33.3687 38.1816H47.6317L40.5181 59.9998ZM35.299 39.5998L40.5181 55.4907L45.7371 39.5998H35.299Z",
    fill: "#FD7E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5492 39.6H21.9653V38.1818H33.1184L29.1147 31.4182L30.2944 30.6909L35.5492 39.6Z",
    fill: "#FD7E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.132 39.6H32.9038L40.5179 29.9272L48.132 39.6ZM35.7636 38.1818H45.2008L40.5179 32.1818L35.7636 38.1818Z",
    fill: "#FD7E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2623 40.1454L29.1147 31.4182L30.2944 30.6909L34.4053 37.6727L39.9461 30.6182L41.0543 31.4909L34.2623 40.1454Z",
    fill: "#FD7E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7382 40.1454L39.9463 31.4909L41.0544 30.6182L46.5952 37.6727L50.7061 30.6909L51.8858 31.4182L46.7382 40.1454Z",
    fill: "#FD7E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.035 39.6H45.4512L50.706 30.6909L51.8856 31.4182L47.882 38.1818H59.035V39.6Z",
    fill: "#FD7E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1969 20H39.8027V24.7273H41.1969V20Z",
    fill: "#FD7E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5172 20.8507L43.7393 25.2183L45.0273 25.7609L46.8053 21.3933L45.5172 20.8507Z",
    fill: "#FD7E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4276 23.8854L47.1421 27.2285L48.128 28.2312L51.4135 24.888L50.4276 23.8854Z",
    fill: "#FD7E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4985 20.8586L34.2104 21.4014L35.9889 25.7689L37.2769 25.2262L35.4985 20.8586Z",
    fill: "#FD7E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6021 23.886L29.6162 24.8887L32.9017 28.2318L33.8876 27.2291L30.6021 23.886Z",
    fill: "#FD7E3B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 6802,
    fill: "white",
    transform: "translate(-777 -5603)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 40,
    fill: "white",
    transform: "translate(21 20)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThought);
export default __webpack_public_path__ + "static/media/thought.ad3003441d2ba860e22b104e2be6f81f.svg";
export { ForwardRef as ReactComponent };